<template>
  <v-app>
    <v-app-bar app clipped-left clipped-right color="#25305E" dark><!-- #1C4E80 green darken-4 7b0a6b 083759 -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px">CULTURA/PR</v-toolbar-title><!-- style="width: 300px" 212px -->

      <v-spacer />

      <v-menu offset-y left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text text-capitalize>
            Marcadores
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense nav>
          <v-list-item to="/marcadores/atividades">
            <v-list-item-icon>
              <v-icon>mdi-drama-masks</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Atividades Culturais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--v-list-item to="/equipamentos">
            <v-list-item-icon>
              <v-icon>mdi-theater</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Equipamentos Culturais</v-list-item-title>
            </v-list-item-content>
          </v-list-item-->

          <!--v-list-item to="/patrimonios">
            <v-list-item-icon>
              <v-icon>mdi-city-variant-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Patrimônios Culturais</v-list-item-title>
            </v-list-item-content>
          </v-list-item-->
        </v-list>
        <v-divider></v-divider>
        <v-list dense nav>
          <!--v-list-item to="/lista/agentes_culturais" subheader>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Agentes Culturais</v-list-item-title>
            </v-list-item-content>
          </v-list-item-->

          <v-list-item to="/lista/instrumento_gestao">
            <v-list-item-icon>
              <v-icon>mdi-account-details</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Instrumento de Gestão</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item to="/sisprofice">
            <v-list-item-icon>
              <v-icon>mdi-account-details</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>SISPROFICE</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text class="mr-6">
            Gráfico
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense nav>
          <v-list-item to="/grafico/atividades">
            <v-list-item-icon>
              <v-icon>mdi-drama-masks</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Atividades Culturais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/equipamento_grafico">
            <v-list-item-icon>
              <v-icon>mdi-theater</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Equipamentos Culturais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-menu>

      <v-progress-circular
        :indeterminate="loading"
      />
<!--
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
-->
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped width="300"><!--  -->
      <Navegacao />
    </v-navigation-drawer>

    <v-main class="grey lighten-5">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </v-main>
<!--
    <v-navigation-drawer app clipped right width="300">

      <InstituicaoEstadual />
      <v-divider />

      <InstituicaoFederal />
      <v-divider />

      <v-card tile flat>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="overlay = !overlay">Overlay</v-btn>
        </v-card-actions>
      </v-card>

      <v-divider />

    </v-navigation-drawer>
-->

    <v-overlay :value="overlay">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-data-table :items="features" :headers="headers" />
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                Propriedades
              </v-card-title>
              <v-card-actions>
                <v-btn icon @click="overlay = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </v-overlay>
  </v-app>
</template>

<script>
import Navegacao from './components/Navegacao'

export default {
  name: 'App',
  components: {
    Navegacao
  },
  data: () => ({
    drawer: true,
    features: [],
    headers: [
      { text: 'Código IBGE', value: 'properties.cod_ibge' },
      { text: 'Campus', value: 'properties.nome_campus'},
      { text: 'Município', value: 'properties.municipio' },
      { text: 'Endereço', value: 'properties.endereco' }
    ],
    overlay: false
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>

<style>
#mapid {
  height: calc(100vh - 64px);
}
.leaflet-container {
  z-index: 0;
}

/* Custom Info Control */
.leaflet-info {
  padding: 6px 8px;
  font: 14px/16px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255,255,255,0.8);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  border-radius: 4px;
/*
  box-shadow: 0 0 15px rgba(0,0,0,0.2);
  border-radius: 5px;
*/
}
.leaflet-info h4 {
  margin: 0 0 5px;
  color: #777;
}
/* Custom Legend Control */
.leaflet-legend {
  line-height: 18px;
  color: #555;
}
.leaflet-legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  opacity: 0.7;
}
/* Custom Changes */

.leaflet-bar {
/*  box-shadow: 0 1px 3px rgba(0,0,0,0.65); */
  box-shadow: 0 1px 5px rgba(0,0,0,.4);
}
.leaflet-popup-content {
  font-family: Roboto;
  font-size: .8125rem;
}
.leaflet-popup-content p {
  margin-top: 8px;
  margin-bottom: 8px !important;
}
/*
.leaflet-popup-content-wrapper {
  border-radius: 4px;
}
.leaflet-popup-content-wrapper, .leaflet-popup-tip {
//  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
*/
.leaflet-bar a, .leaflet-bar a:hover {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: black !important;
/*
  color: white !important;
  background-color: black !important;
*/
}
.leaflet-touch .leaflet-bar a{
  width: 30px;
  height: 30px;
  line-height: 30px;
}

/* Custom Controls */
/*
.leaflet-control-homeextent-toggle {
  background-image: url('assets/homeextent.svg');
}
*/
.leaflet-control-getfeatureinfo-toggle {
  background-image: url('assets/information-variant.svg');
}
a.leaflet-control-active, a.leaflet-control-active:hover {
  background-color: #4CAF50;
}

/* Geocodificação - Tamanho do Botão */
.leaflet-control-geocoder-icon {
  width: 30px !important;
  height: 30px !important;
}
/* Geoman */
.leaflet-pm-toolbar .leaflet-buttons-control-button {
  padding: 6px;
}

/* Browser Print */
ul.browser-print-holder {
  padding-left: 0px !important;
}
</style>
